module.exports = __webpack_public_path__ + "img/bnr-today-sp.e0243c0f.jpg";